import BaseElement from './BaseElement';
import HealthscoreDetail from '../Components/Profile/HealthscoreDetail';
class HealthscoreDetailElement extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = HealthscoreDetail;
    }
}
export const loadHealthscoreDetailElement = () => {
    customElements.define('healthscore-detail', HealthscoreDetailElement);
};
